import DownloadIcon from "@mui/icons-material/Download";
import React, { useEffect, useState } from "react";
import { getGlossaryDocument, getGlossaryDocumentBlob } from "../../../api/faqApi";

const FALLBACK_FILE_NAME = "cedar-glossary.xlsx";

export const GlossaryTileContent = () => {
  // Fetched as a blob (see faqApi.ts) and turned into an object URL - a plain <a href> pointed
  // straight at the backend's /faq/glossary/document/download wouldn't carry the bearer-token
  // auth every other call here needs. Revoked on unmount so the object URL doesn't leak.
  const [documentUrl, setDocumentUrl] = useState<string | null>(null);
  const [fileName, setFileName] = useState(FALLBACK_FILE_NAME);

  useEffect(() => {
    let objectUrl: string | null = null;

    getGlossaryDocument().then((document) => {
      if (document && !("error" in document)) setFileName(document.file_name);
    });

    getGlossaryDocumentBlob().then((blob) => {
      if (blob instanceof Blob) {
        objectUrl = URL.createObjectURL(blob);
        setDocumentUrl(objectUrl);
      }
    });

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, []);

  return (
    <>
      <p className="faq_tile_text">
        Download the official Data Analysis &amp; Insights glossary to align on KPI definitions, datasources and calculation logic across
        teams.
      </p>
      {documentUrl && (
        <a className="faq_button_primary" href={documentUrl} download={fileName} data-test-id="glossary-download-button">
          <DownloadIcon fontSize="small" />
          Download glossary (XLSX)
        </a>
      )}
    </>
  );
};
